<template>
  <div class="inner-content">
    <div class="scroll-box">
      <div class="center" v-html="lg(config, 'bonus_rules', '')"></div>
    </div>
  </div>
</template>
 
<script setup>
import lg from '@/utils/lg'
import { useConfig } from '@/composables/useConfig'

defineOptions({ name: 'PrizeRule' })

const config = useConfig()
</script>

<style lang="scss" scoped>

.inner-content {
  width: 1066px;
  height: 565px;
  overflow: hidden;
  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: pre-line;
    .center {
      height: 379px;
      margin: 30px 59px;
      font-size: 20px;
      font-weight: 500;
      color: #666;
      :deep(p) {
        margin-top: 0;
        margin-bottom: 15px;
        display: flex;
        padding-left: 25px;
      }
      :deep(h3) {
        font-weight: normal;
        margin: 30px 0 15px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          content: map-get($icon_singles, 'rule_bullet');
          width: 27px;
          height: 27px;
          margin-right: 7px;
        }
      }
    }
  }
}
  
</style>
